import { render, staticRenderFns } from "./addSubscriber.vue?vue&type=template&id=611d0612&"
import script from "./addSubscriber.vue?vue&type=script&lang=js&"
export * from "./addSubscriber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports